/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-console */
import { useToast } from '@abyss/web/hooks/useToast';
import { Button } from '@abyss/web/ui/Button';
import { Link } from '@abyss/web/ui/Link';
import { AccountSection } from '@src/app/AccountSection';
import React from 'react';
import { logoutAndRedirect, onSessionTimeout } from '../auth/logout';
import { sessionCountdown } from '../auth/sessionCountdown';
import { HeaderBar } from './HeaderBar';

const SIDEBAR_WIDTH = 260;

export const AppHeader = ({ user }) => {
  const { toast } = useToast();
  sessionCountdown.setToast(toast);
  sessionCountdown.setOnTimedOut(onSessionTimeout);

  return (
    <React.Fragment>
      <HeaderBar>
        <Link href="/" id="logoLink" variant="native">
          <img src="/assets/dfeds_logo.svg" alt="dFEDS Logo" />
        </Link>

        <div
          className="headerRight"
          data-testid="main-header-right"
          data-cy="main-header-right"
        >
          <div>
            <Button
              data-cy="logout"
              // eslint-disable-next-line react/jsx-no-bind
              onClick={logoutAndRedirect}
              size="$md"
              variant="outline"
            >
              <span>Logout</span>
            </Button>
          </div>

          <div id="accountSection" data-cy="menu-account">
            <AccountSection sidebarWidth={SIDEBAR_WIDTH} user={user} />
          </div>
        </div>
      </HeaderBar>
    </React.Fragment>
  );
};
